<template>
  <div class="add-or-edit-permission">
    <el-page-header @back="goBack" :content="pathTitle">
    </el-page-header>
    <el-form ref="form" :model="form" label-width="80px">
      <el-form-item label="角色名称">
        <el-input v-model="form.name" style="width: 217px;" :readonly="true"></el-input>
      </el-form-item>
      <el-form-item label="状态">
        <el-select v-model="form.status" placeholder="请选状态">
          <el-option label="有效" value="1"></el-option>
          <el-option label="无效" value="0"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="权限列表">
        <template>
          <el-tree
            ref="tree"
            :data="roleListData"
            show-checkbox
            node-key="id"
            highlight-current
            :default-checked-keys="form.authorityIdList"
            default-expand-all>
          </el-tree>
        </template>
      </el-form-item>
      <el-form-item>
        <el-button @click="goBack" size="small" style="width: 80px;">取消</el-button>
        <el-button type="primary" @click="onSubmit" size="small" style="width: 80px;">确定</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
  import {
    permissionModules
  } from '@r'
  export default {
    data() {
      return {
        roleListData: [],
        form: {
          "accessRoleCodeList": [],
          "accessUrl": "",
          "matchType": "1",
          "name": "",
          "resourceId": -1,
          "status": "1",
          "type": "1",
        },
        pathTitle: "",
      }
    },
    activated() {
      this.form = {
        "authorityIdList": this.$route.query.authorityIdList,
        "name": this.$route.query.name,
        "id": this.$route.query.id,
        "status": this.$route.query.status,
        "role": this.$route.query.role
      }
      permissionModules.getRoleTreeMap().then((res) => {
        if (res.result !== 1) {
          this.$message({
            type: 'error',
            message: res.message ? res.message : '获取权限列表失败'
          });
          return
        }
        this.roleListData = res.ldata;
      }).catch((err) => {
        this.$message({
          type: 'error',
          message: err.message ? err.message : '未知错误'
        });
      })
      this.pathTitle = '编辑权限';
    },
    methods: {
      goBack() {
        this.$router.go(-1);
      },
      onSubmit() {
        let authorityIdList = this.$refs.tree.getCheckedKeys();
        authorityIdList = authorityIdList.filter(n => n);
        permissionModules.editRoleAuthority({
          id: this.form.id,
          authorityIdList: JSON.stringify(authorityIdList),
          status: this.form.status,
          role: this.form.role,
        }).then((res) => {
          if (res.result !== 1) {
            this.$message({
              type: 'error',
              message: res.message ? res.message : '编辑失败'
            });
            return
          }
          this.roleListData = res.ldata;
          this.$message({
            type: 'success',
            message: "编辑成功"
          });
          this.goBack();
        }).catch((err) => {
          this.$message({
            type: 'error',
            message: err.message ? err.message : '未知错误'
          });
        })
      },
    }
  }
</script>

<style lang="scss">
  .el-form {
    margin-top: 20px;
  }
</style>
